import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=4c47e4e8&scoped=true&"
import script from "./Contacts.vue?vue&type=script&async=true&lang=js&"
export * from "./Contacts.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=4c47e4e8&lang=scss&scoped=true&"
import style1 from "./Contacts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47e4e8",
  null
  
)

export default component.exports